import { trigger, transition, style, animate } from '@angular/animations';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'lum-ui-popover',
  templateUrl: './ui-popover.component.html',
  styleUrls: ['./ui-popover.component.scss'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate(200, style({ opacity: 1 })),
      ]),
      transition(':leave', [animate(200, style({ opacity: 0 }))]),
    ]),
  ],
})
export class UiPopoverComponent implements OnInit {
  @Input()
  cssClasses :string = '';

  @Output()
  setContentVisibleEvent = new EventEmitter<boolean>();

  show :boolean = false;

  constructor() {}

  ngOnInit() :void {}

  onSetContentVisible(toggle :boolean) :void {
    this.show = toggle;
    this.setContentVisibleEvent.emit(toggle);
  }

  get classes() :string[] {
    return [this.cssClasses];
  }
}
